export default (function replaceTrialText(eventGroup) {
  eventGroup.events.forEach((event, eventIndex, events) => {
    events[eventIndex].text = event.text.replace(/>[^<].{5}/g, ">TRIAL");
  });
  return eventGroup;
});